module.exports = __webpack_public_path__ + "static/media/accept.0ed3d522.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accept.png
// module id = 1579
// module chunks = 0